import React, { useEffect, useState } from "react";
import LoginUi from "./LoginUi";
import { useNavigate } from "react-router-dom";
import {
  useReSendOtpMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
} from "../../store/Api/auth";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendOtpApi] = useSendOtpMutation();
  const [resendEnabled, setResendEnabled] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [verifyOtp] = useVerifyOtpMutation();
  const [reSendOtp] = useReSendOtpMutation();
  const [showOtp, setShowOtp] = useState(false);
  const [snackbar, setSnackbar] = useState("");
  const [resStatus,setResStatus] = useState("");
  // Start the timer when the OTP page loads
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setResendEnabled(true); // Enable Resend OTP button when timer reaches 0
    }
  }, [timeLeft]);
  const validationSchema = Yup.object(
    showOtp
      ? {
          phoneNumber: Yup.string()
            .required("Phone number is required")
            .matches(/^\d{10}$/, "Enter 10 Digits Phone Number"),
            otp: Yup.string()
            .length(6, "OTP must be 6 digits")
            .matches(/^[0-9]{6}$/, "OTP must be a valid 6 digit number")
            .required("OTP is required"),
            // termsAccepted: Yup.boolean()
            // .oneOf([true], "You must accept the Terms and Conditions")
            // .required("You must accept the Terms and Conditions"),
        }
      : {
          phoneNumber: Yup.string()
            .required("Phone number is required")
            .matches(/^\d{10}$/, "Enter 10 Digits Phone Number"),
            // termsAccepted: Yup.boolean()
            // .oneOf([true], "You must accept the Terms and Conditions")
            // .required("You must accept the Terms and Conditions"),
         
        }
  );

  const handleSubmit = async (values) => {
    try {
      const response = await sendOtpApi({
        phone_number: values?.phoneNumber,
        platform: "web",
      });
      if (response?.data?.success) {
        setShowOtp(true);
        setResStatus("success")
        setSnackbar(response?.data?.message);
        // navigate("/otp", { state: { phoneNumber: values?.phoneNumber } });
      } else if (response?.error?.data?.message) {
        setResStatus("error")
        setSnackbar(response?.error?.data?.message);
      }
    } catch (error) {
      console.log(error, "send otp error");
    }
  };
  const onOtpChange = (newOtp) => {
    setOtp(newOtp.split(""));
  };

  const handleOtpSubmit = async (values) => {
    // Add your OTP submission logic here
    const otpData = {
      phone_number: values?.phoneNumber,
      otp: values.otp,
    };
    try {
      const response = await verifyOtp(otpData);
  
      if (response?.data?.success) {
        setShowOtp(true);
        setResStatus("success")
        setSnackbar(response?.data?.message);
        navigate("/");
        // navigate("/otp", { state: { phoneNumber: values?.phoneNumber } });
      } else if (response?.error?.data?.message) {
        setResStatus("error")
        setSnackbar(response?.error?.data?.message);
        // setTimeout(() => setSnackbar(""), 3000);
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };

  const handleResendOtp = async (phoneNumber, setFieldValue ) => {
    setTimeLeft(60); // Reset timer when Resend OTP is clicked
    setResendEnabled(false); // Disable Resend OTP button until the next minute
    setOtp(["", "", "", "", "", ""]); // Reset OTP input
    setFieldValue("otp", "");
    // Call your resend OTP API here
    try {
      const response = await reSendOtp({ phone_number: phoneNumber });
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  
  return (
    <Formik
      initialValues={
         { phoneNumber: "", otp: otp.join("") ,termsAccepted: true} 
      }
      validationSchema={validationSchema}
      validateOnChange={false}
      onSubmit={showOtp ? handleOtpSubmit : handleSubmit}
    >
      {({ values, handleChange, handleSubmit, errors, touched ,setFieldValue  }) => (
        <LoginUi
          phoneNumber={values.phoneNumber}
          errors={errors}
          touched={touched}
          onphoneNumberChange={handleChange("phoneNumber")}
          onSubmit={handleSubmit}
          otp={values?.otp?.split("")}
          onOtpChange={(newOtp) => {
            onOtpChange(newOtp);
            handleChange({ target: { name: "otp", value: newOtp } });
          }}
          timeLeft={timeLeft}
          resendEnabled={resendEnabled}
          handleResendOtp={(phone) => handleResendOtp(phone, setFieldValue)}
          showOtp={showOtp}
          termsAccepted={values.termsAccepted}
          onTermsChange={handleChange("termsAccepted")}
          snackbar={snackbar}
          resStatus={resStatus}
        />
      )}
    </Formik>
  );
}

export default Login;
